import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { EnviromentEnum } from './enviroment.enum';
import { LogService } from './error.model';

export const WINDOW = new InjectionToken<Window>('WINDOW');
export const ENVIROMENT = new InjectionToken<EnviromentEnum>('ENVIROMENT');
export const LOG_SERVICE = new InjectionToken<LogService>('LOG_SERVICE');
export const BASE_URL = new InjectionToken<string>('BASE_URL');
export const WEBSOCKET_URL = new InjectionToken<string>('WEBSOCKET_URL');
export const LANGUAGE = new InjectionToken<string>('LANGUAGE');
export const DEFAULT_LANGUAGE = new InjectionToken<string>('DEFAULT_LANGUAGE');
export const PLATFORM = new InjectionToken<string>('PLATFORM');
export const BROWSER = new InjectionToken<string>('BROWSER');
export const POINTER_TYPE = new InjectionToken<'coarse' | 'fine' | 'none'>('POINTER_TYPE');
export const HOVER_TYPE = new InjectionToken<boolean>('HOVER_TYPE');
export const IS_INCOGNITO = new InjectionToken<boolean>('IS_INCOGNITO');
export const SUPPORT_LAZY_LOADING = new InjectionToken<boolean>('SUPPORT_LAZY_LOADING');
export const IS_BROWSER = new InjectionToken<boolean>('IS_BROWSER');
export const IS_PRERENDER = new InjectionToken<boolean>('IS_PRERENDER');
export const GET_IP = new InjectionToken<Promise<string>>('GET_IP');
export const POP_STATE = new InjectionToken<Observable<boolean>>('POP_STATE');
// export const LOCATION_ORIGIN = new InjectionToken<string>('LOCATION_ORIGIN');
